import axios from 'axios';
import Router from '@/router';
/**
  *  Vue Instance Definition
  */

let instance;

export const getInstance = () => instance;

let baseURL = process.env.VUE_APP_API_URL || 'https://sideop-api.hermosillo.gob.mx/graphql';
if (process.env.NODE_ENV !== 'production') {
  baseURL = 'http://localhost:4000/graphql';
}

/**
  *  Vue Instance Initialization
  */

export const useAuth = (Vue) => {
  if (instance) return instance;

  instance = new Vue(
    {
      data() {
        return {
          isLoading: true,
          isAuthenticated: false,
          user: {},
          error: null,
        };
      },
      methods: {
        validarRuta(pathRuta, authRuta) {
          /** ********
            authRuta: Puede contener los siguientes valores.
            true = Requiere Autenticación solamente.
            false = No requiere Autenticación, ni scopes.
            [] = Requiere Autenticación solamente.
            ['scope1', 'scope2] = Requiere Autenticación y Scopes descritos en el array
          ********* */

          if (Array.isArray(this.user.scopes) && authRuta) {
            this.validaScopes(pathRuta, authRuta);
          } else if (pathRuta !== '/logout') {
            // Inicializa la promesa para esperar la respuesta del validarToken
            const esperaValidarToken = this.refrescar();
            // Concluida la promesa realiza el siguiente paso en then
            esperaValidarToken.then(() => {
              this.validaScopes(pathRuta, authRuta);
            });
          }
        },
        formattedUser(user) {
          return {
            id: user.id,
            correoElectronico: user.correoElectronico,
            nombre: user.funcionario ? user.funcionario.nombre : user.contratista.nombreRazonSocial,
            puesto: user.puesto || null,
            esSupervisor: user.funcionario?.esSupervisor || false,
            avatarPublicKey: user.avatarPublicKey,
            roles: user.roles,
            scopes: user.scopes,
          };
        },
        validaScopes(pathRuta, authRuta) {
          // Obtiene el tipo de dato de la autorizacion de Ruta
          const tipoAuthRuta = typeof (authRuta);
          // Obtiene true o false, si la auth requiere autenticación de la ruta
          const rutaRequiereAutenticacion = !!((tipoAuthRuta === 'boolean' && authRuta === true)
          || (tipoAuthRuta === 'object' && Array.isArray(authRuta)));
            // Obtiene true o false, si la auth requiere Scopes especificos
          const rutaRequiereScopes = !!((tipoAuthRuta === 'object' && Array.isArray(authRuta) && authRuta.length > 0));
          // Obtiene true o false, si Usuario esta autenticado
          const usuarioEstaAutenticado = this.isAuthenticated;
          // VALIDAR TIPO DE USUARIO CONTRATISTA
          if (this.isAuthenticated
              && this.user.roles.includes('CONTRATISTA:SUPERVISION')
              && Router.history.current.name === 'login') {
            Router.push({ name: 'contratistas' });
            return;
          }
          // Inicializa que el usuario No tiene scopes
          let usuarioTieneScopes = false;
          // Evalua los Scopes del usuario con los Scopes
          // que requiere la ruta, devuelve true o false
          if (Array.isArray(this.user.scopes)) {
            usuarioTieneScopes = this.user.scopes.map((s) => {
              if (Array.isArray(authRuta) && authRuta.includes(s)) return true;
              return false;
            }).includes(true);
          }
          /*
          console.log('VALIDAR RUTA .', pathRuta,
            '\nRequiereAuth-->', rutaRequiereAutenticacion,
            '\nusuarioEstaAuth-->', usuarioEstaAutenticado,
            '\nauthRuta-->', authRuta,
            '\nrutaRequiereScopes-->', rutaRequiereScopes,
            '\nUsuarioTieneScopes-->', usuarioTieneScopes,
            '\nScopes-->', this.user.scopes);
          */

          /* Evalua las condiciones para continuar
            o no a la ruta de acuerdo a sus condiciones de
            autenticación y scopes especificos */
          // Evalua ruta No requiere Autenticacion, continua en la ruta
          if (!rutaRequiereAutenticacion) return;
          /* Evalua ruta requiere autenticación y
             usuario no esta autenticado, envia a función noAuth (login) */
          if (!(rutaRequiereAutenticacion && usuarioEstaAutenticado)) { console.warn('---------Ruta sin acceso'); this.noAuth(); return; }
          // Evalua ruta No requiere Scopes, continua en la ruta
          if (!rutaRequiereScopes) {
            // console.log('----------RutaNorequiereScopes--------');
            return;
          }
          /* Evalua ruta requiere Scopes y usuario no tiene
             Scope especifico, envia a ruta restringida */
          if (!(rutaRequiereScopes && usuarioTieneScopes)) {
            // console.warn('-------------Ruta Denegada por scope----------');
            Router.push({ name: 'rutarestringida' });
          }
          // console.log(`-------------Ruta ${pathRuta} sigue----------`);
        },

        noAuth() {
          const rutaActual = Router.history.current.name;
          this.isLoading = false;
          this.isAuthenticated = false;
          localStorage.removeItem(process.env.VUE_APP_AUTH_TOKEN || 'sideop-app-hermosillo');
          if (rutaActual === 'login' || !rutaActual) return;
          Router.push({ name: 'login' });
        },

        async validarTolkenActual(token) {
          // Se esta valido el token del usuario
          this.isLoading = true;

          // Enviar la peticion
          await axios.post(baseURL, {
            query: `mutation {
              verificarToken {
                status
                token
                usuario {
                  id
                  funcionario {
                    id
                    nombre
                    puesto
                    esSupervisor
                  }
                  contratista {
                    id
                    nombreRazonSocial
                  },
                  avatarPublicKey
                  correoElectronico
                  roles
                  scopes
                }
              }
            }`,
          }, {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
            },
          })
            .then(({ data }) => {
              // Comprobar que traiga datos
              const { data: inData } = data;
              if (!inData) {
                this.noAuth();
                return;
              }

              // Comprobar que el token sea valido
              const { verificarToken } = inData;
              if (!verificarToken.status) {
                this.noAuth();
                return;
              }

              this.isLoading = false;
              this.isAuthenticated = true;

              // Igualar los datos del usuario
              this.user = this.formattedUser(verificarToken.usuario);

              localStorage.setItem(process.env.VUE_APP_AUTH_TOKEN || 'sideop-app-hermosillo', verificarToken.token);
            })
            .catch((err) => console.log({ err }));
        },

        async refrescar() {
          // Extraer el token guardado
          const token = localStorage.getItem(process.env.VUE_APP_AUTH_TOKEN || 'sideop-app-hermosillo');
          // Comprobar que exista el token
          if (!token) {
            // Si no existe entonces envuar a noAuth
            this.noAuth();
          }
          // Validar el token guardado
          await this.validarTolkenActual(token);
        },
        validaScopesActions(accionValida = 'noenvioaccion') {
          let accion = accionValida;
          const acciones = ['ver', 'crear', 'editar', 'eliminar'];
          // Si acción a validar es blanco retorna falso
          if (accion === '') return false;
          if (typeof (accion) === 'number') {
            accion = acciones[accion];
          }
          // Si en la instancia no auth users scopes retorna falso
          if (!this.$auth.user.scopes) return false;
          // Extrae los scopes de la ruta actual
          const scopesModulo = Router.history.current.meta.scopes || [];
          // if (scopesModulo.length === 0) return true;
          // Extrae los scopes de la ruta actual que coinciden con la acción a validar
          const scopesAccion = scopesModulo.filter((s) => s.includes(accion));
          /*
          console.log('scope-->', accion,
            'scopesModulo-->', scopesModulo,
            'scopeAccion--->', scopesAccion,
            'retorna--->', this.$auth.user.scopes.includes(...scopesAccion.map((s) => s)));
          */
          // Retorna true si los scopes del usuario coinciden con el de scope de acción
          return this.$auth.user.scopes.includes(...scopesAccion.map((s) => s));
        },
      },
      async created() {
        // Refrescar el token
        // await this.refrescar();

        // Traes la ruta actual en la que estamos parados
        const rutaActual = Router.history.current.name;
        // Comprobar que que la ruta donde estemos no sea el login y que este Autenticado
        if (rutaActual === 'login' && this.isAuthenticated) {
          Router.push({ name: 'administracion' });
        }
        // if (rutaActual === 'login') Router.push({ name: 'administracion' });
      },

    },
  );

  return instance;
};

/**
  *  Vue Plugin Definition
  */
export const Auth = {
  install(Vue) {
    const vue = Vue;
    vue.prototype.$auth = useAuth(Vue);
  },
};
